import React, { FC } from 'react';
import styled from 'styled-components';
import { theme as t } from '../AssetUrlTheme';

const Root = styled.div.attrs({ 'data-test': 'asset-url' })`
  display: flex;
  align-items: center;

  padding: ${t.container.padding};
  background-color: ${t.container.backgroundColor};
  border: 1px solid ${t.container.borderColor};
  border-radius: ${t.container.borderRadius};
`;

const AssetUrlContainer: FC<{ children: React.ReactNode }> = ({ children }) => <Root>{children}</Root>;
export default AssetUrlContainer;
